import { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";

import { APIMS } from "../../../../../../config/apims";
import ToastError from "../../../../../NotificationToast/ToastError";
import ToastSuccess from "../../../../../NotificationToast/ToastSuccess";

import "bulma/css/bulma.css";
import "../../../../../../index.css";

export default function ModalAcaraUpdate(props) {
  const token = localStorage.getItem("token");
  const idUser = localStorage
    .getItem("id_admin")
    ?.replace(/[|&;$%@"<>()+,]/g, "");

  const [nameEvent, setNameEvent] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const fetchParams = {
    headers: {
      Authorization: `${token}`,
      "Content-Type": "application/json",
    },
  };

  useEffect(() => {
    setNameEvent(props?.nameUpdate || "");
  }, [props?.nameUpdate]);

  const handleSubmit = async (event) => {
    event.preventDefault();

    const cleanName = nameEvent.trim();

    if (!cleanName || isSubmitting) {
      return;
    }

    setIsSubmitting(true);

    try {
      const response = await APIMS.put(
        `/api/events/${props.id}`,
        {
          name_event: cleanName,
          user_id: idUser,
        },
        fetchParams
      );

      if (response?.status === 200) {
        ToastSuccess.fire({
          icon: "success",
          title: response?.data?.message || "Data berhasil diperbarui",
        });

        props.GetResponseData();
        props.onHide();
      }
    } catch (error) {
      ToastError.fire({
        icon: "error",
        title: error?.response?.data?.message || "Gagal memperbarui data",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal
      show={props.show}
      onHide={props.onHide}
      centered
      backdrop="static"
      keyboard={false}
      dialogClassName="module-modal-dialog"
      contentClassName="module-modal-content"
      aria-labelledby="modal-update-tipe-acara"
    >
      <form onSubmit={handleSubmit}>
        <div className="module-modal-header">
          <div>
            <h5 id="modal-update-tipe-acara" className="module-modal-title">
              Update Tipe Acara
            </h5>
          </div>

          <button
            type="button"
            className="module-modal-close"
            onClick={props.onHide}
            disabled={isSubmitting}
            aria-label="Tutup modal"
          >
            <FontAwesomeIcon icon={faXmark} />
          </button>
        </div>

        <Modal.Body className="module-modal-body mt-1 mx-2">
          <div className="module-form-grid">
            <div className="module-form-group module-form-span-2">
              <label
                className="module-form-label"
                htmlFor="name_event_update"
              >
                Tipe Acara <span>*</span>
              </label>
              <input
                id="name_event_update"
                className="module-form-input"
                autoFocus
                type="text"
                name="name_event"
                value={nameEvent}
                onChange={(event) => setNameEvent(event.target.value)}
                
                disabled={isSubmitting}
                required
              />
            </div>
          </div>
        </Modal.Body>

        <div className="module-modal-footer">
          <button
            type="button"
            className="module-modal-cancel"
            onClick={props.onHide}
            disabled={isSubmitting}
          >
            Batal
          </button>

          <button
            type="submit"
            className="module-modal-submit"
            disabled={isSubmitting || !nameEvent.trim()}
          >
            {isSubmitting && <span className="module-button-spinner" />}
            {isSubmitting ? "Memperbarui..." : "Perbarui"}
          </button>
        </div>
      </form>
    </Modal>
  );
}
